import { render } from "./baseMultiSelect.vue?vue&type=template&id=0a8169ad"
import script from "./baseMultiSelect.vue?vue&type=script&lang=js"
export * from "./baseMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__